// A plain, unsigned decimal — digits with an optional "." and more digits.
// Number() also accepts hex ('0x64') and exponential ('1e3') notation, which
// are never what a buyer typed into a Bid Sheet amount cell, so this is
// checked first rather than trusting Number.isFinite alone. Shared between
// the lot-level Bid Submission check and the per-unit rollup so both entry
// points reject the same malformed input.
export const PLAIN_DECIMAL = /^\d+(\.\d+)?$/

// Trims before testing so a value the buyer pasted or typed with
// surrounding whitespace in the review-screen edit box (the inline path,
// unlike the CSV path, doesn't trim ahead of validation) isn't rejected on
// that basis alone.
export const parsePlainDecimal = (raw: string): number | null => {
  const trimmed = raw.trim()
  return PLAIN_DECIMAL.test(trimmed) ? Number(trimmed) : null
}
